import { useReducerContext } from "./reducer-context";
export default useReducerContext;